export default "__VITE_ASSET__CJToBt8g__"